var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-template",style:(_vm.cssObject)},[_c('img',{ref:_vm.getComponentRefName(_vm.component),attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }